<template>
  <section class="product-cancellation">
    <div class="travel-tabs">
      <div class="tab-icons" :class="isSavingData ? 'is-saving' : ''">
        <div
          v-if="salesAdditiveType === 'Alterar'"
          class="tab grayscale"
          :class="activeTab === 'product' ? 'active' : ''"
          @click="onClickActiveTab('product')"
        >
          <img
            src="@/assets/images/dashboard/contracts/flight-ico.png"
            alt="img"
            height="30"
          />
        </div>
        <div
          class="tab grayscale"
          :class="activeTab === 'financial' ? 'active' : ''"
          @click="onClickActiveTab('financial')"
        >
          <img
            src="@/assets/images/dashboard/contracts/financial-icon.png"
            alt="img"
            height="30"
          />
        </div>

        <div
          class="tab grayscale"
          :class="activeTab === 'incomings' ? 'active' : ''"
          @click="onClickActiveTab('incomings')"
          v-if="fineFee || supplierFineFee"
        >
          <img
            src="@/assets/images/dashboard/contracts/incomings-icon.png"
            alt="img"
            height="30"
          />
        </div>
      </div>
      <div class="tab-content">
        <aRow>
          <aCol class="inner-content" :span="24">
            <template v-if="activeTab === 'product'">
              <div class="tab-header">Produto</div>
              <div class="pr-10 pt-10">
                <ContractModalFlightRow
                  :product="productToCancel"
                  :tempContract="tempContract"
                  :allContractData="allContractData"
                  :selectedRows="selectedRows"
                  @onChangeCancelProductData="onChangeCancelProductData"
                  @onIsSavingData="onIsSavingData"
                  type="edit"
                />
              </div>
            </template>
            <template v-if="activeTab === 'financial'">
              <div class="tab-header">Financeiro</div>
              <div class="pr-10 pt-10">
                <ContractCancelFlightFinancialForm
                  :product="productToCancel"
                  :tempContract="tempContract"
                  :salesAdditiveType="salesAdditiveType"
                  :totalFees="totalFees"
                  @onChangeCancelProductData="onChangeCancelProductData"
                  @onChangeFees="onChangeCancelProductData"
                  @onIsSavingData="onIsSavingData"
                  @onChangeFeeValue="onChangeFeeValue"
                />
              </div>
            </template>
            <template
              v-if="activeTab === 'incomings' && (fineFee || supplierFineFee)"
            >
              <div class="tab-header">Recebimentos</div>
              <div class="pr-10 pt-10">
                <ContractPaymentsReceivable
                  :tempContract="tempContract"
                  :productsToCancel="productsToCancel"
                  :keyPrefix="''"
                  :keySuffix="'_new'"
                  :baseId="baseId"
                  :baseFinancesId="baseFinancesId"
                  :salesAdditiveType="salesAdditiveType"
                  @onIsSavingData="onIsSavingData"
                  @onChangeCancelProductData="onChangeCancelProductData"
                />
              </div>
            </template>
          </aCol>
          <aCol
            v-if="['Alterar', 'Cancelar'].includes(salesAdditiveType)"
            :span="24"
          >
            <aRow class="footer" :gutter="20" align="middle">
              <aCol class="disclaimer f12" :span="16">
                <b>Atenção:</b> Preencha todos os campos obrigatórios para
                {{ salesAdditiveType }} o produto.
              </aCol>
              <aCol class="a-right" :span="8">
                <aButton
                  icon="close-circle"
                  type="danger"
                  :disabled="disableCancelProduct"
                  style="padding: 0 10px"
                  @click="onClickCancelProduct"
                >
                  {{ salesAdditiveType }} Produto
                </aButton>
              </aCol>
            </aRow>

            <aModal
              class="cancel-sale-modal"
              :visible="openCancelProductModal"
              :footer="false"
              :width="600"
              @cancel="openCancelProductModal = false"
            >
              <template #title>
                <div class="upper">{{ salesAdditiveType }} PRODUTO</div>
              </template>

              <ContractCancelProductModal
                v-if="openCancelProductModal"
                :tempContract="tempContract"
                :allContractData="allContractData"
                :cancelActions="cancelActions"
                :productValues="productValues()"
                :salesAdditiveType="salesAdditiveType"
                @onFinishActions="onFinishActions"
              />
            </aModal>
          </aCol>
        </aRow>
        <div id="live-debug">
          <json-viewer
            :value="tempContract"
            :show-array-index="false"
            :expand-depth="1"
          ></json-viewer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";

import formatThings from "@/mixins/general/formatThings.js";
import ContractModalFlightRow from "../sections/ContractModalFlightRow.vue";
import ContractCancelFlightFinancialForm from "../sections/ContractCancelFlightFinancialForm.vue";
import ContractPaymentsReceivable from "../sections/ContractPaymentsReceivable.vue";
import ContractCancelProductModal from "./ContractCancelProductModal.vue";

export default {
  name: "CancelFlightModal",
  props: {
    productToCancel: Object,
    tempContract: Object,
    salesAdditiveType: String,
    allContractData: Object,
    productsToCancel: Array,
    totalFees: Number,
  },
  components: {
    ContractModalFlightRow,
    ContractCancelFlightFinancialForm,
    ContractPaymentsReceivable,
    ContractCancelProductModal,
  },
  mixins: [formatThings],
  data() {
    return {
      activeTab: "financial",
      disableCancelProduct: true,
      isSavingData: false,
      fineFee: false,
      supplierFineFee: false,
      openCancelProductModal: false,
      baseId: `flight_${this.productToCancel.id}`,
      baseFinancesId: `contract_finances_flight_${this.productToCancel.id}`,
      cancelActions: [],
      selectedRows: [],
    };
  },
  mounted() {
    if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
      this.activeTab =
        this.salesAdditiveType === "Alterar" ? "product" : "financial";
      this.verifyProductForCancellation();

      const getParseStoredValue = (key) => {
        if (!this.tempContract || !this.productToCancel) return [];
        const value = this.tempContract[`${this.baseId}_${key}`];
        return value ? JSON.parse(value) : [];
      };

      this.selectedRows = getParseStoredValue("cancel_selected_rows");
    }

    this.fineFee = this.checkActive(
      this.tempContract[`${this.baseFinancesId}_fine_fee_active`]
    );

    this.supplierFineFee = this.checkActive(
      this.tempContract[`${this.baseFinancesId}_supplier_fine_fee_active`]
    );
  },
  methods: {
    onFinishActions() {
      this.openCancelProductModal = false;
      this.$emit("onFinishActions");
    },
    onContractCancelProductFinish() {
      this.openCancelProductModal = false;
      this.$emit("onContractCancelProductFinish");
    },
    onChangeFeeValue() {
      this.onChangeCancelProductData(this.tempContract);
    },
    onClickCancelProduct() {
      let total = 0;
      let totalFees = 0;
      let taxInfo = "";

      this.cancelActions = [];

      if (this.fineFee) {
        totalFees += parse(
          this.tempContract[`${this.baseFinancesId}_fine_fee_value`]
        );
      }

      if (this.supplierFineFee) {
        totalFees += parse(
          this.tempContract[`${this.baseFinancesId}_supplier_fine_fee_value`]
        );
      }

      if (
        this.checkActive(
          this.tempContract[`${this.baseId}_financial_data_active`]
        )
      ) {
        total = this.newProductValues().rawTotal;
      } else {
        total = this.flightValues().total;
      }

      this.newProductValues();

      if (totalFees != 0) {
        taxInfo = `<div class="f11 red mt-5">➟ O valor de <b class="cred">${this.formatPricePtBr(
          totalFees
        )}</b> das multas foi descontado na Carta de Crédito.</div>`;
      }

      this.cancelActions.push({
        text: `Uma <b>CARTA DE CRÉDITO</b> no valor de <b class="cgreen">${this.formatPricePtBr(
          total - totalFees
        )}</b> será gerada no nome do cliente <b>${
          this.tempContract.the_customer.first_name
        } ${this.tempContract.the_customer.last_name} (ID: ${
          this.tempContract.the_customer.id
        })</b>. ${taxInfo}`,
        done: false,
        loading: false,
      });

      this.cancelActions.push({
        text: `Um novo <b>CONTRATO</b> será gerado com as novas informações do produto.`,
        done: false,
        loading: false,
      });

      this.cancelActions.push({
        text: `Uma nova <b>VENDA</b> será gerada no nome do cliente.`,
        done: false,
        loading: false,
      });

      this.openCancelProductModal = true;
    },
    productValues() {
      const total = this.allContractData.flight.toReceiveList.filter((item) => {
        return item.id == `flight-${this.productToCancel.id}`;
      });

      const toPay = this.allContractData.flight.netList.filter((item) => {
        return item.id == `flight-${this.productToCancel.id}`;
      });

      const profit = this.allContractData.flight.profitList.filter((item) => {
        return item.id == `flight-${this.productToCancel.id}`;
      });

      const taxes = this.allContractData.flight.extraFeesList.filter((item) => {
        return item.id == `flight-${this.productToCancel.id}`;
      });

      return {
        total: total.length ? total[0] : {},
        toPay: toPay.length ? toPay[0] : {},
        profit: profit.length ? profit[0] : {},
        taxes: taxes.length ? taxes[0] : {},
      };
    },
    flightValues() {
      let value = 0;
      let taxes = 0;
      let duTax = 0;
      let tebAgency = 0;

      if (this.tempContract[`${this.baseId}_type`] === "Regular") {
        const shouldProcessAll =
          this.selectedRows.length === 0 &&
          this.productToCancel.travellers.length > 1;

        this.productToCancel.travellers.forEach((traveller) => {
          if (
            ["Alterar", "Cancelar"].includes(this.salesAdditiveType) &&
            !shouldProcessAll &&
            !this.selectedRows.includes(traveller.id)
          ) {
            return;
          }

          const fields = ["value", "taxes", "du_tax", "teb_agency"];
          const baseKey = `${this.baseId}_traveller_${traveller.id}_`;

          fields.forEach((field) => {
            const key = baseKey + field;
            const amount = parse(this.tempContract[key]) || 0;

            switch (field) {
              case "value":
                value += amount;
                break;
              case "taxes":
                taxes += amount;
                break;
              case "du_tax":
                duTax += amount;
                break;
              case "teb_agency":
                tebAgency += amount;
                break;
            }
          });
        });
      }

      return {
        taxes: taxes,
        profit: duTax,
        total: value + taxes + duTax + tebAgency,
        toPay: value,
      };
    },
    newProductValues() {
      let total = parse(this.tempContract[`${this.baseId}_total_price_new`]);
      let toPay = parse(
        this.tempContract[`${this.baseFinancesId}_net_value_new`]
      );
      let profit = 0;
      let taxes = 0;

      if (
        this.tempContract[`${this.baseFinancesId}_taxes_rows_new`] != undefined
      ) {
        JSON.parse(
          this.tempContract[`${this.baseFinancesId}_taxes_rows_new`]
        ).forEach((tax) => {
          if (
            this.tempContract[
              `${this.baseFinancesId}_tax_${tax.id}_type_new`
            ] &&
            this.tempContract[`${this.baseFinancesId}_tax_${tax.id}_value_new`]
          ) {
            taxes += parse(
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_tax_${tax.id}_add_in_total_new`
              ] == 1
            ) {
              total += parse(
                this.tempContract[
                  `${this.baseFinancesId}_tax_${tax.id}_value_new`
                ]
              );
            }
          }
        });
      }

      if (
        this.tempContract[`${this.baseFinancesId}_incentives_rows_new`] !=
        undefined
      ) {
        JSON.parse(
          this.tempContract[`${this.baseFinancesId}_incentives_rows_new`]
        ).forEach((incentive) => {
          if (
            this.tempContract[
              `${this.baseFinancesId}_incentive_${incentive.id}_type_new`
            ] == "%"
          ) {
            profit += parseFloat(
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_percentage_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == 1
            ) {
              total += parseFloat(
                this.tempContract[
                  `${this.baseFinancesId}_incentive_${incentive.id}_percentage_value_new`
                ]
              );
            }
          } else {
            profit += parse(
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_value_new`
              ]
            );

            if (
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == true ||
              this.tempContract[
                `${this.baseFinancesId}_incentive_${incentive.id}_add_in_total_new`
              ] == 1
            ) {
              total += parse(
                this.tempContract[
                  `${this.baseFinancesId}_incentive_${incentive.id}_value_new`
                ]
              );
            }
          }
        });
      }

      return {
        total: this.formatPricePtBr(total),
        rawTotal: total,
        toPay: this.formatPricePtBr(toPay),
        rawTotalToPay: toPay,
        profit: this.formatPricePtBr(total - toPay + profit),
        rawProfit: total - toPay + profit,
        taxes: this.formatPricePtBr(taxes),
        rawTaxes: taxes,
      };
    },
    verifyProductForCancellation() {
      let disable = true;

      // const paymentMethods =
      //   this.tempContract["payment_methods_new"] != undefined
      //     ? JSON.parse(this.tempContract["payment_methods_new"])
      //     : [];

      if (["Alterar", "Cancelar"].includes(this.salesAdditiveType)) {
        if (this.fineFee) {
          if (
            !this.isEmptyOrInvalid(
              this.tempContract[`${this.baseFinancesId}_fine_fee_value`]
            )
          ) {
            disable = false;
          } else {
            disable = true;
          }
        }

        if (this.supplierFineFee) {
          if (
            !this.isEmptyOrInvalid(
              this.tempContract[
                `${this.baseFinancesId}_supplier_fine_fee_value`
              ]
            )
          ) {
            disable = false;
          } else {
            disable = true;
          }
        }
      }

      if (this.salesAdditiveType === "Alterar") {
        this.productToCancel.sections.forEach((section) => {
          if (this.selectedRows.includes(section.id)) {
            this.productToCancel.travellers;
            if (
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_departure_date_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_departure_time_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_class_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_airline_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_arrival_date_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_arrival_time_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_duration_new`
                ]
              ) ||
              this.isEmptyOrInvalid(
                this.tempContract[
                  `${this.baseId}_section_${section.id}_number_new`
                ]
              )
            ) {
              disable = true;
            } else {
              disable = false;
            }
          }
        });
      }

      this.disableCancelProduct = disable;
    },
    onChangeCancelProductData(tempContract) {
      this.$emit("onChangeCancelProductData", tempContract);

      this.fineFee = this.checkActive(
        tempContract[`${this.baseFinancesId}_fine_fee_active`]
      );
      this.supplierFineFee = this.checkActive(
        tempContract[`${this.baseFinancesId}_supplier_fine_fee_active`]
      );

      this.selectedRows = tempContract[`${this.baseId}_cancel_selected_rows`]
        ? JSON.parse(tempContract[`${this.baseId}_cancel_selected_rows`])
        : [];

      this.verifyProductForCancellation();
    },
    onClickActiveTab(active) {
      this.activeTab = active;
    },
    onIsSavingData(loading) {
      this.isSavingData = loading;
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #e0e0e0;
$btn-color: #ff4545;

.is-saving {
  filter: grayscale(0);
  -webkit-filter: grayscale(0%);
  pointer-events: none;
  opacity: 0.3;
}

.data-row {
  background: #fff;
  padding: 10px;
  border: 1px solid #ddd !important;
  margin: 0 0 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  .label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    color: #aaa;
  }
}

.product-cancellation {
  .travel-tabs {
    height: 642px;
    .tab-icons {
      float: left;
      border-right: 1px solid $border-color;
      width: 75px;
      height: 642px;
      text-align: center;
      .tab {
        float: left;
        height: 60px;
        width: 100%;
        line-height: 56px;
        cursor: pointer;
        transition: 0.6s;
        opacity: 0.6;
        border-bottom: 1px solid #e0e0e0;
      }
      & :hover,
      .active {
        filter: none;
        -webkit-filter: grayscale(0);
        -webkit-filter: grayscale(0%);
        opacity: 1;
      }
    }
    .tab-content {
      position: relative;
      height: 642px;
      margin-left: 75px;
      padding: 0 10px;
      .inner-content {
        overflow: auto;
        height: 595px;
        width: 101.4%;
        .tab-header {
          border-bottom: 1px solid $border-color;
          padding: 10px 0;
          font-weight: 600;
        }
      }
      .footer {
        display: flex;
        border-top: 1px solid $border-color;
        padding: 10px 0;
        align-items: center;
        .disclaimer {
          color: #3c3c3c;
          font-weight: 500;
          b {
            color: $btn-color;
          }
        }

        button {
          padding: 0px 20px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
